/***
 * model representing a connection or friend.
 */
import Backbone from 'backbone';

var DeleteConnection = Backbone.Model.extend({
    idAttribute: 'connectionRequestId',

    backend: 'gcapi',

    url: function() {
        return '/userprofile-service/connection/decline/' + this.connectionRequestId;
    },

    initialize: function(args) {
        this.connectionRequestId = args.connectionRequestId;
    }
});

export default DeleteConnection;
